<template>
  <div class="admin-container">
    <div class="header-toolbar">
      <h2>订单管理</h2>
      <div>
        <el-button type="info" @click="goBack" style="margin-right: 10px"
          >返回</el-button
        >
        <el-button
          v-if="userRole === 'super_admin'"
          type="primary"
          @click="goToCreateAccount"
          style="margin-right: 10px"
        >
          创建账号
        </el-button>
        <el-button
          v-if="userRole === 'super_admin'"
          type="success"
          @click="goToAccountList"
          style="margin-right: 10px"
        >
          账号管理
        </el-button>
        <el-button
          type="warning"
          @click="goToOrderCreate"
          style="margin-right: 10px"
          >新增订单</el-button
        >
        <el-button
          type="danger"
          @click="goToOrderImport"
          style="margin-right: 10px"
          >订单导入</el-button
        >
        <el-button
          v-if="userRole === 'admin' || userRole === 'super_admin'"
          type="primary"
          @click="handleExport"
          style="margin-right: 10px"
        >
          导出订单
        </el-button>
        <el-button
          v-if="userRole === 'admin' || userRole === 'super_admin'"
          type="primary"
          @click="handleExportCurrentPage"
          style="margin-right: 10px"
        >
          导出当前页
        </el-button>
        <el-button
          v-if="userRole === 'admin' || userRole === 'super_admin'"
          type="primary"
          @click="goToLoginLog"
          style="margin-right: 10px"
        >
          登录日志
        </el-button>
        <el-button
          type="danger"
          @click="goToOrderStatus"
          style="margin-right: 10px"
          >订单状态</el-button
        >
        <el-button type="danger" @click="logout">退出登录</el-button>
      </div>
    </div>

    <div class="search-bar" style="margin-bottom: 20px">
      <el-input
        v-model="searchForm.customerNo"
        placeholder="输入客户编号搜索"
        style="width: 200px; margin-right: 10px"
      ></el-input>
      <el-input
        v-model="searchForm.piNo"
        placeholder="输入PI号搜索"
        style="width: 200px; margin-right: 10px"
      ></el-input>
      <el-input
        v-model="searchForm.poNo"
        placeholder="输入PO号搜索"
        style="width: 200px; margin-right: 10px"
      ></el-input>
      <el-input
        v-model="searchForm.mvbProductModel"
        placeholder="输入MVB产品型号搜索"
        style="width: 220px; margin-right: 10px"
      ></el-input>
      <el-input
        v-model="searchForm.productModel"
        placeholder="输入产品型号搜索"
        style="width: 200px; margin-right: 10px"
      ></el-input>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="handleReset" style="margin-left: 10px">重置</el-button>
    </div>

    <div
      class="table-container"
      style="
        background: #fff;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      "
    >
      <el-table
        :data="orderList"
        border
        stripe
        style="width: 100%"
        row-key="id"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <el-table-column
          label="客户编号"
          prop="customerNo"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          label="PO号"
          prop="poNo"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          label="PI号"
          prop="piNo"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          label="MVB产品型号"
          prop="mvbProductModel"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          label="产品型号"
          prop="productModel"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          label="产品代码"
          prop="productCode"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          label="条形码"
          prop="barcode"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          label="订单数量"
          prop="orderQuantity"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          label="已完成数量"
          prop="completedQuantity"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          label="预计交期"
          prop="estimatedDeliveryDate"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          label="更新时间"
          prop="updateTime"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column label="进度" width="150" align="center">
          <template slot-scope="scope">
            <el-progress
              :percentage="scope.row.progress * 100"
              size="small"
            ></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="goToOrderEdit(scope.row.id)"
              >编辑</el-button
            >
            <el-button
              type="text"
              style="color: red"
              @click="deleteOrder(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div
      class="pagination"
      style="margin-top: 20px; text-align: right"
      v-if="total > 0"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { adminOrderPage, adminDeleteOrder } from "@/api/order";
import { Message, MessageBox } from "element-ui";

export default {
  name: "AdminOrderList",
  data() {
    return {
      orderList: [],
      userRole: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      searchForm: {
        customerNo: "",
        piNo: "",
        poNo: "",
        mvbProductModel: "",
        productModel: "",
      },
    };
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {
      role: "admin",
    };
    this.userRole = userInfo.role;
    this.getOrderList();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToCreateAccount() {
      this.$router.push("/account/create");
    },
    goToAccountList() {
      this.$router.push("/account/list");
    },
    goToOrderCreate() {
      this.$router.push("/admin/order-create");
    },
    goToOrderImport() {
      this.$router.push("/admin/order-import");
    },
    goToOrderStatus() {
      this.$router.push("/admin/order-status");
    },
    goToLoginLog() {
      this.$router.push("/admin/login-log");
    },
    handleExport() {
      const params = new URLSearchParams();

      if (this.searchForm.customerNo && this.searchForm.customerNo.trim()) {
        params.append("customerNo", this.searchForm.customerNo.trim());
      }
      if (this.searchForm.piNo && this.searchForm.piNo.trim()) {
        params.append("piNo", this.searchForm.piNo.trim());
      }
      if (this.searchForm.poNo && this.searchForm.poNo.trim()) {
        params.append("poNo", this.searchForm.poNo.trim());
      }
      if (this.searchForm.mvbProductModel && this.searchForm.mvbProductModel.trim()) {
        params.append("mvbProductModel", this.searchForm.mvbProductModel.trim());
      }
      if (this.searchForm.productModel && this.searchForm.productModel.trim()) {
        params.append("productModel", this.searchForm.productModel.trim());
      }
      const query = params.toString();
      const url = "/api/order/admin/export" + (query ? `?${query}` : "");
      window.open(url, "_blank");
    },
    handleExportCurrentPage() {
      const params = new URLSearchParams();
      params.append("pageNum", this.currentPage);
      params.append("pageSize", this.pageSize);
      if (this.searchForm.customerNo && this.searchForm.customerNo.trim()) {
        params.append("customerNo", this.searchForm.customerNo.trim());
      }
      if (this.searchForm.piNo && this.searchForm.piNo.trim()) {
        params.append("piNo", this.searchForm.piNo.trim());
      }
      if (this.searchForm.poNo && this.searchForm.poNo.trim()) {
        params.append("poNo", this.searchForm.poNo.trim());
      }
      if (this.searchForm.mvbProductModel && this.searchForm.mvbProductModel.trim()) {
        params.append("mvbProductModel", this.searchForm.mvbProductModel.trim());
      }
      if (this.searchForm.productModel && this.searchForm.productModel.trim()) {
        params.append("productModel", this.searchForm.productModel.trim());
      }
      const query = params.toString();
      const url = "/api/order/admin/exportPage" + (query ? `?${query}` : "");
      window.open(url, "_blank");
    },

    goToOrderEdit(orderId) {
      this.$router.push({
        path: "/admin/order-create",
        query: { id: orderId },
      });
    },
    logout() {
      localStorage.removeItem("userInfo");
      this.$router.push("/login");
      Message.success("退出登录成功");
    },

    getOrderList() {
      if (this.loading) return;
      this.loading = true;
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchForm,
      };
      adminOrderPage(params)
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.orderList = res.records || [];
            this.total = res.total || 0;
          } else {
            Message.error("获取订单失败：" + (res.msg || "未知错误"));
            this.orderList = [];
            this.total = 0;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error("获取订单失败:", err);
          console.error("后端错误详情:", err.response?.data);
          Message.error("获取订单数据失败，请重试");
          this.orderList = [];
          this.total = 0;
        });
    },

    deleteOrder(orderId) {
      MessageBox.confirm("确定删除该订单？删除后不可恢复！", "警告", {
        type: "warning",
      })
        .then(() => {
          adminDeleteOrder(orderId)
            .then((res) => {
              if (res.code === 200) {
                Message.success("删除成功");
                this.getOrderList();
              } else {
                Message.error("删除失败：" + (res.msg || "未知错误"));
              }
            })
            .catch((err) => {
              console.error("删除订单异常:", err);
              Message.error("删除失败，请重试");
            });
        })
        .catch(() => Message.info("已取消删除"));
    },

    handleSearch() {
      this.currentPage = 1;
      this.getOrderList();
    },

    handleReset() {
      this.searchForm = {
        customerNo: "",
        piNo: "",
        poNo: "",
        mvbProductModel: "",
        productModel: "",
      };
      this.currentPage = 1;
      this.getOrderList();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.getOrderList();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getOrderList();
    },
  },
};
</script>

<style scoped>
.admin-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.header-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.search-bar {
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.table-container {
  margin-bottom: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  height: 600px;
  overflow: auto;
}
.el-table th,
.el-table td {
  text-align: center;
  vertical-align: middle;
}
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.7);
}
</style>